import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { TextInput } from "../../../components/textInput/textInput";
import { FindItemIcon } from "../../../assets/icons";
import { useEffect, useState } from "react";
import { CafeItem } from "./cafeItem";
import { PageLoader } from "../../../components/loader/pageLoader";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAdminCafe } from "../../../features/userReducer";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";

import { Text } from "../../../components/text/text";
import { Button } from "../../../components/button/button";
import styles from "./cafeList.module.css"

export const AdminCafeListPage = () => {
    const [search, setSearch] = useState("");
    const dispatch = useDispatch();
    const navigate = useAnimatedNavigate();

    const { cafes, cafesLoading } = useSelector(state => state.user.adminData);

    const withoutCategory = [];
    const categories = {};
    for (const item of cafes) {
        if (item.group) {
            if (!Object.keys(categories).includes(item.group)) {
                categories[item.group] = [item];
            } else {
                categories[item.group].push(item);
            }
        } else {
            withoutCategory.push(item);
        }
    }

    if (cafesLoading) {
        return <PageLoader />
    }


    return (
        <>
            <AdminHeader title="Ваши предприятия" />
            <TextInput value={search} setValue={setSearch} leftContent={<FindItemIcon />} />

            {
                !cafesLoading &&
                <div className={styles.categories}>
                    {
                        withoutCategory.length > 0 &&
                        <div className={styles.coffee_shops_buttons}>
                            {
                                withoutCategory.filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                                    <CafeItem
                                        key={data.id}
                                        data={data}
                                        onClick={() => {
                                            dispatch(setSelectedAdminCafe({
                                                cafeId: data.id,
                                                maxCountEmp: data.maxCountEmp,
                                            }));
                                            navigate(`${data.id}`);
                                        }}
                                    />
                                )
                            }
                        </div>
                    }

                    {
                        Object.keys(categories).map(group => (
                            <div className={styles.category} key={group}>
                                <Text as="div" variant="body" className={styles.category_name} >{group}</Text>
                                <div className={styles.coffee_shops_buttons}>
                                    {
                                        categories[group].filter(item => item.name.toLowerCase().includes(search.trim().toLowerCase())).map(data =>
                                            <CafeItem
                                                key={data.id}
                                                data={data}
                                                onClick={() => {
                                                    dispatch(setSelectedAdminCafe({
                                                        cafeId: data.id,
                                                        maxCountEmp: data.maxCountEmp,
                                                    }));
                                                    navigate(`${data.id}`);
                                                }}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            }

            <div className={styles.pageSpacer} />

            <div className={styles.bottomActions}>
                <Button
                    text="Получить сравнительный отчёт по выручке"
                    onClick={() => navigate("/admin/comparative-revenue-report")}
                />
            </div>
        </>
    )
}
